/**
 * What an AI-generated cover is for. The admin sends it over HTTP and the service validates it, so
 * without a shared home the two lists drift apart without anything failing to compile.
 */
export const CoverTarget = {
  PRODUCT: "product",
  PRODUCT_RESOURCE: "resource",
} as const;

export type CoverTargetEnum = (typeof CoverTarget)[keyof typeof CoverTarget];

/** A tuple, so `z.enum(coverTargets)` keeps the literal types instead of widening to string. */
export const coverTargets = [CoverTarget.PRODUCT, CoverTarget.PRODUCT_RESOURCE] as const;
